import React from 'react';
interface LanguageDropdownProps {
  langOptions: {
    code: string;
    label: string;
    shortLabel: string;
    flag: string;
  }[];
  language: string;
  setLanguage: (lang: string) => void;
  setIsLangOpen: (isOpen: boolean) => void;
}
export function LanguageDropdown({
  langOptions,
  language,
  setLanguage,
  setIsLangOpen
}: LanguageDropdownProps) {
  return <div className="absolute top-full right-0 mt-1.5 w-40 rounded-xl shadow-xl bg-white ring-1 ring-slate-900/5 z-50 overflow-hidden" data-id="element-15987">
      <div className="p-1" data-id="element-15988">
        {langOptions.map(lang => <button key={lang.code} onClick={() => {
        setLanguage(lang.code);
        setIsLangOpen(false);
      }} className={`flex items-center gap-2.5 w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${language === lang.code ? 'bg-indigo-50 text-indigo-600 font-semibold' : 'text-slate-700 hover:bg-slate-50'}`} data-id="element-15989">
            <span className="text-base" data-id="element-15990">{lang.flag}</span>
            <span data-id="element-15991">{lang.label}</span>
          </button>)}
      </div>
    </div>;
}